<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import Intersect from 'vue-intersect';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  components: {
    Intersect
  },
  data() {
    return {
      contents: [],
      paging: {},
      paddingYDefault: 5,
      loading: false
    };
  },
  computed: {
    cursorAfter() {
      return this.paging?.cursors?.after ?? "";
    }
  },
  methods: {
    sendAnalyticsData() {
      sendFandomAnalyticsEvent("Interaction", "Social Post Click", "Not defined");
    },
    fetchItems() {
      this.loading = true;
      Fandom.ajax({
        method: "GET",
        url: Fandom.applyContextToUrl("/api/v5/meta_business/instagram_contents"),
        data: {
          after: this.cursorAfter
        },
        success: (response) => {
          if (response.success) {
            this.paging = response.paging;
            this.contents = this.contents.concat(response.data);
          } else {
            console.log("%cerror: " + response.error, "color: red");
          }
        }
      }, () => {
        this.loading = false;
      })
    }
  }
};

</script>

<template>
  <intersect @enter.once="fetchItems()">
    <div v-easyadmin="easyadminId" :class="[contentType, paddingY]" :style="theme" class="themed-item" v-if="isContentVisibleToUser()" grid-instagram-component>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <stripe-header :content="content" v-if="content.title || content.title_composed"></stripe-header>
            <div class="juicer-content" v-html="content.description" @click="sendAnalyticsData()"></div>
          </div>
        </div>
        <div class="row row-cols-lg-4 row-cols-md-2 row-cols-1 custom-gutter">
          <div class="col" v-for="content in contents">
            <tile-instagram :content="content"></tile-instagram>
          </div>
        </div>
        <div class="row justify-content-center" v-if="cursorAfter">
          <div class="col-auto pt-3">
            <button class="btn btn-primary" @click="fetchItems()" :disabled="loading">{{ft("globals.load_more")}}</button>
          </div>
        </div>
      </div>
    </div>
  </intersect>
</template>
<style lang="scss">
[grid-instagram-component] {

  .row.custom-gutter { 
    margin-left: -10px;
    margin-right: -10px;

    > .col {
      padding: 10px;
    }
  }
}
</style>